var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-type"},[_c('span',{staticClass:"account-type__currency-img symbol",class:`symbol-${_vm.accountCurrency}`}),_c('div',{staticClass:"account-type__name",class:_vm.getAccountCLass(_vm.accountType)},[_vm._v(_vm._s(_vm.accountType)+" account")])])
}
var staticRenderFns = []

export { render, staticRenderFns }